import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import axios from 'axios'

    export const getTaxList = createAsyncThunk('appVehicleType/getTaxList', async (params) => {
      const response = await axios.post('https://api.zasway.com:8443/Common/GetTaxList', params, {mode: 'cors'})
      return response.data
    })

    export const GetVehicleTag = createAsyncThunk('appVehicleType/GetVehicleTagList', async () => {
      const response = await axios.post('https://api.zasway.com:8443/Vehicle/GetVehicleTagList', {mode:'cors'})
      return response.data
      })

      export const UploadFile = createAsyncThunk('appVehicleType/UploadFile', async (formData) => {
        const response = await axios.post('https://api.zasway.com:8443/VehicleType/UploadFile', formData, {mode:'cors'})
        return response
      })
      export const addVehicleType = createAsyncThunk('appVehicleType/Create', async (formData) => {
        const response = await axios.post('https://api.zasway.com:8443/VehicleType/Create', formData, {mode:'cors'})
        return response
      })

      export const EditVehicleType = createAsyncThunk('appVehicleType/Update', async (formData) => {
        const response = await axios.post('https://api.zasway.com:8443/VehicleType/Update', formData, {mode:'cors'})
        return response
      })

      export const getData = createAsyncThunk('appVehicle/getData', async (params) => {
         
        const response = await axios.post('https://api.zasway.com:8443/VehicleType/GetTableSummary', params, {mode:'cors'})
        return {
          params,
          data: response.data.data,
          allData: response.data.allData,
          totalPages: response.data.total
        }
      })

      export const deleteVehicleType = createAsyncThunk('appVehicle/Delete', async (id, { dispatch, getState }) => {
        const response = await axios.post('https://api.zasway.com:8443/VehicleType/Delete', id, {mode:'cors'})
        await dispatch(getData(getState().vehicleType.params))
        return response
      })

      export const getAllData = createAsyncThunk('appVehicle/GetTableSummary', async (GetVehicle) => {
      const response = await axios.post('https://api.zasway.com:8443/Vehicle/GetTableSummary', GetVehicle, {mode:'cors'})
      return response
      })

  export const appVehicleTypeSlice = createSlice({
    name: 'appVehicle',
    initialState: {
      data: [],
      total: 1,
      params: {},
      allData: []
    },
    reducers: {},
    extraReducers: builder => {
      builder
        
        .addCase(getData.fulfilled, (state, action) => {
          state.data = action.payload.data
          state.allData = action.payload.allData
          state.total = action.payload.totalPages
          state.params = action.payload.params
        })
    }
  })
  
  export default appVehicleTypeSlice.reducer
